module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/pathways-deco-left-92bffa72343ed778ee80cd9b4b96f0bc.svg";